import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import {
  TiimeButtonModule,
  TiimeDialogModule,
  TiimeIconModule,
  TiimeInputContainerModule,
  TiimeSearchBarModule,
  TiimeTableModule,
  TiimeTooltipModule
} from 'tiime-material';

import { SimpleCellComponent } from '@shared-cells/simple-cell/simple-cell.component';
import { ListErrorComponent } from '@shared-components/list-error/list-error.component';

import { ExonerationZonesDialogComponent } from './exoneration-zones-dialog.component';

@NgModule({
  declarations: [ExonerationZonesDialogComponent],
  imports: [
    CommonModule,
    TiimeDialogModule,
    TiimeButtonModule,
    TiimeTableModule,
    TiimeSearchBarModule,
    TiimeInputContainerModule,
    TiimeIconModule,
    SimpleCellComponent,
    TiimeTooltipModule,
    ReactiveFormsModule,
    ListErrorComponent
  ]
})
export class ExonerationZonesDialogModule {}
